import { Link } from 'components/navigation/Link/Link';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import React from 'react';
import { convertAccountFromSlapiToCmp } from '../helpers/credit_info';
import { cloneDataObject } from '../helpers/objectHelpers';

const typeAccountsActionPlan = {
  latePayment30: {
    title: 'Make a payment on your 30 days late accounts',
    accounts: [],
    message:
      'Make payment or even partial payment as soon as possible to reduce impact on your credit score.',
  },
  latePayment60: {
    title: 'Make a payment on your 60 days late accounts',
    accounts: [],
    message:
      'Make payment if possible or contact the creditor to  see if they are willing to set up a payment plan.',
  },
  latePayment90: {
    title: 'Make a payment on your 90 days late accounts',
    accounts: [],
    message:
      'Make payment if possible or contact the creditor to see if they are willing to set up a payment plan. If you have a good payment history with this creditor ask for a goodwill adjustment.',
  },
  latePayment120: {
    title: 'Make a payment on your 120 days late accounts',
    accounts: [],
    message:
      'Make payment if possible or contact the creditor to see if they are willing to set up a payment plan. If you have a good payment history with this creditor ask for a goodwill adjustment.',
  },
  collectionChargeOff: {
    title: 'A collections agency may contact you about your accounts',
    accounts: [],
    message:
      'Do not ignore.  Contact the collections agency to see if you can negotiate a settlement or payment plan.',
    showCollectionBanner: true,
  },
  collections: {
    title: 'Take action on your collections',
    accounts: [],
    message:
      'Do not ignore.  Contact the collections agency and work out a payment plan or settlement.',
    showCollectionBanner: true,
  },
  chargeOffs: {
    title: 'Be prepared to speak with a collections agency about your accounts',
    accounts: [],
    message:
      'Your creditor has written-off this debt as uncollectible but may have sold it to a collections agency.',
  },
  bankruptcy: {
    title: 'Your bankruptcy filing is now listed on your credit report',
    accounts: [],
    message: null,
  },
  foreClosure: {
    title: 'Negotiate with your lender about the foreclosure',
    accounts: [],
    message:
      'Your lender may be willing to remove the foreclosure from your credit report if you agree to pay a portion of your debt.',
  },
};

export const onClickCheckAll3BureauCreditReport = (eventHandler, module) => {
  eventHandler(CLICK, {
    'Click Type': 'Enroll Premium Negative Mark Score Increase',
    'Module Name': module,
  });
};

export const checkAll3BureauCreditReport = (eventHandler, module) => {
  const onClickCheckCreditReport = () => {
    onClickCheckAll3BureauCreditReport(eventHandler, module);
  };
  return (
    <>
      <Link onClickCallback={onClickCheckCreditReport} to="/creditReports/view">
        Check all 3-bureau{' '}
      </Link>{' '}
      to credit reports to be sure it is accurate and all debts are discharged.
    </>
  );
};

export const useNegativeMarks = (creditInfo, eventHandler, module) => {
  const paymentHistoryAnalysis =
    creditInfo?.creditScoreAnalysis?.paymentHistory;
  const typeAccountsActionPlanClone = cloneDataObject(typeAccountsActionPlan);

  const delinquentAccounts = paymentHistoryAnalysis?.negativeRemarkAccounts
    .filter(a => /.*[Ll]ate.*/.test(a.remarks))
    .map(item =>
      convertAccountFromSlapiToCmp({ ...item, negativeMarkType: 'Delinquent' }),
    );
  const derogatoryAccounts = paymentHistoryAnalysis?.negativeRemarkAccounts
    .filter(a => !/.*[Ll]ate.*/.test(a.remarks))
    .map(item =>
      convertAccountFromSlapiToCmp({ ...item, negativeMarkType: 'Derogatory' }),
    );

  const combinedAccounts = delinquentAccounts.concat(derogatoryAccounts);

  combinedAccounts.forEach(account => {
    const remarkToLowerCase = account.remark.toLowerCase();
    if (remarkToLowerCase.includes('30')) {
      typeAccountsActionPlanClone['latePayment30'].accounts.push(account);
    } else if (remarkToLowerCase.includes('60')) {
      typeAccountsActionPlanClone['latePayment60'].accounts.push(account);
    } else if (remarkToLowerCase.includes('90')) {
      typeAccountsActionPlanClone['latePayment90'].accounts.push(account);
    } else if (remarkToLowerCase.includes('120')) {
      typeAccountsActionPlanClone['latePayment120'].accounts.push(account);
    } else if (
      remarkToLowerCase.includes('collection') &&
      remarkToLowerCase.includes('chargeoff')
    ) {
      typeAccountsActionPlanClone['collectionChargeOff'].accounts.push(account);
    } else if (remarkToLowerCase.includes('collection')) {
      typeAccountsActionPlanClone['collections'].accounts.push(account);
    } else if (remarkToLowerCase.includes('chargeoff')) {
      typeAccountsActionPlanClone['chargeOffs'].accounts.push(account);
    } else if (remarkToLowerCase.includes('bankruptcy')) {
      typeAccountsActionPlanClone['bankruptcy'].accounts.push(account);
    } else if (remarkToLowerCase.includes('foreclosure')) {
      typeAccountsActionPlanClone['foreClosure'].accounts.push(account);
    }
  });
  typeAccountsActionPlanClone['bankruptcy'].message =
    checkAll3BureauCreditReport(eventHandler, module);
  const actionPlanSteps = [];

  for (const key in typeAccountsActionPlanClone) {
    if (typeAccountsActionPlanClone[key]?.accounts?.length > 0) {
      actionPlanSteps.push(typeAccountsActionPlanClone[key]);
    }
  }

  return {
    actionPlanSteps,
    delinquentAccounts,
    derogatoryAccounts,
  };
};
